// Automation System Configuration
export const AUTOMATION_CONFIG = {
  // Backend API Configuration (using AWS Bedrock)
  backend: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://server.spatialgrid.ai',
    endpoint: '/api/v1/bedrock/automation/interpret',
    timeout: 30000, // 30 seconds
    retryAttempts: 3,
  },

  // Tool Configuration
  tools: {
    enableFallback: true, // Enable fallback parsing when AI fails
    maxToolCalls: 5, // Maximum number of tool calls per command
    executionDelay: 100, // Delay between multiple object additions (ms)
  },

  // Scene Configuration
  scene: {
    defaultPosition: { x: 0, y: 0, z: 0 },
    maxObjects: 1000, // Maximum objects allowed in scene
    autoCleanup: true, // Automatically clean up invalid objects
  },

  // Logging Configuration
  logging: {
    level: 'info', // debug, info, warn, error
    enableConsole: true,
    enableFile: false,
    logFile: 'automation.log',
  },
};

// Environment-specific overrides
export const getConfig = () => {
  const config = { ...AUTOMATION_CONFIG };

  // Override with environment variables if available
  if (process.env.REACT_APP_API_URL) {
    config.backend.apiUrl = process.env.REACT_APP_API_URL;
  }

  return config;
};

// Validation functions
export const validateConfig = (config) => {
  const errors = [];

  if (!config.backend.apiUrl) {
    errors.push('Backend API URL is required');
  }

  if (config.tools.maxToolCalls < 1 || config.tools.maxToolCalls > 20) {
    errors.push('Max tool calls must be between 1 and 20');
  }

  return errors;
};
